var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNogoX32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NOGO32",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #NOGO32 .cls-1 {\n        fill: #ff7600;\n      }\n\n      #NOGO32 .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-795 -279)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(795 279)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1648",
    "data-name": "Rechteck 1648",
    className: "cls-2",
    width: 20,
    height: 4,
    transform: "translate(801 293)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNogoX32);
export default __webpack_public_path__ + "static/media/nogo-x32.561345d80ab7c212239fc6efcc5c7de0.svg";
export { ForwardRef as ReactComponent };